import { inject, Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { first, Observable } from 'rxjs';

import { PerformanceLoaderKey } from '@core/enums';
import {
  PerformanceMetricHistoryParams,
  PerformanceMetricHistoryResponse,
  PerformanceMetricsParams,
  PerformanceMetricsResponse,
} from '@core/models/performance.model';
import { ApiService } from '@core/services/api.service';
import { LoadingService } from '@core/services/loading';
import { SnackbarService } from '@core/services/snackbar.service';

@Injectable({ providedIn: 'root' })
export class PerformanceApiService {
  private readonly api = inject(ApiService);
  private readonly loader = inject(LoadingService);
  private readonly snack = inject(SnackbarService);

  getMetrics(params: PerformanceMetricsParams): Observable<PerformanceMetricsResponse> {
    const httpParams = new HttpParams().set('timePeriod', params.timePeriod);
    return this.api
      .get<PerformanceMetricsResponse>(`v1/performance/${params.supplierId}/metrics`, { params: httpParams })
      .pipe(first(), this.loader.set(PerformanceLoaderKey.GET_METRICS), this.snack.operator());
  }

  getMetricHistory(params: PerformanceMetricHistoryParams): Observable<PerformanceMetricHistoryResponse> {
    const httpParams = new HttpParams().set('periodType', params.timePeriod);
    return this.api
      .get<PerformanceMetricHistoryResponse>(
        `v1/performance/${params.supplierId}/metrics/${params.metricKey}/trend`,
        { params: httpParams },
      )
      .pipe(first(), this.loader.set(PerformanceLoaderKey.GET_METRIC_HISTORY), this.snack.operator());
  }
}
